export default __webpack_public_path__ + "static/media/undraw_empty.0c0a4b7f.svg";